import { ProviderType } from "./ObjectTypes";

export const v1_technologies: ProviderType[] = [
  {
    name: "Argos",
    id: "",
    value: "argos",
    help_center_url: "https://support.earthranger.com/en_US/animal-tracking/argos",
    description: "",
    actions: []
  },
  {
    name: "Baytrac",
    id: "",
    value: "baytrac",
    help_center_url: "https://support.earthranger.com/en_US/vehicle-trackers/baytrac",
    description: "",
    actions: []
  },
  {
    name: "Bidtrack",
    id: "",
    value: "bidtrack",
    help_center_url: "https://support.earthranger.com/en_US/vehicle-trackers/bidtrack",
    description: "",
    actions: []
  },
  {
    name: "CarTrack",
    id: "",
    value: "cartrack",
    help_center_url: "https://support.earthranger.com/en_US/vehicle-trackers/cartrack",
    description: "",
    actions: []
  },
  {
    name: "Ceres Wild",
    id: "",
    value: "ceres-wild",
    help_center_url: "https://support.earthranger.com/en_US/animal-tracking/ceres-wild",
    description: "",
    actions: []
  },
  {
    name: "Druid Technology",
    id: "",
    value: "druid-technology",
    help_center_url: "https://support.earthranger.com/en_US/animal-tracking/druid-technology",
    description: "",
    actions: []
  },
  {
    name: "EarthRanger to EarthRanger",
    id: "",
    value: "er2er",
    help_center_url: "https://support.earthranger.com/en_US/earthranger_conservation_software/er2er",
    description: "",
    actions: []
  },
  {
    name: "EzyTrack",
    id: "",
    value: "ezytrack",
    help_center_url: "https://support.earthranger.com/en_US/vehicle-trackers/ezytrack",
    description: "",
    actions: []
  },
  {
    name: "Fargo Tracking, Wells Fargo",
    id: "",
    value: "wells-fargo-tracking",
    help_center_url: "https://support.earthranger.com/en_US/vehicle-trackers/wells-fargo-tracking",
    description: "",
    actions: []
  },
  {
    name: "FindMy",
    id: "",
    value: "findmy",
    help_center_url: "https://support.earthranger.com/en_US/animal-tracking/findmy",
    description: "",
    actions: []
  },
  {
    name: "Flow",
    id: "",
    value: "flow-tech-solutions",
    help_center_url: "https://support.earthranger.com/en_US/animal-tracking/flow-tech-solutions",
    description: "",
    actions: []
  },
  {
    name: "Followit",
    id: "",
    value: "followit",
    help_center_url: "https://support.earthranger.com/en_US/animal-tracking/followit",
    description: "",
    actions: []
  },
  {
    name: "Gestfrota",
    id: "",
    value: "gesfrota",
    help_center_url: "https://support.earthranger.com/en_US/vehicle-trackers/gesfrota",
    description: "",
    actions: []
  },
  {
    name: "GSatSolar",
    id: "",
    value: "gsatsolar",
    help_center_url: "https://support.earthranger.com/en_US/animal-tracking/gsatsolar",
    description: "",
    actions: []
  },
  {
    name: "ICUServer",
    id: "",
    value: "icuserver",
    help_center_url: "https://support.earthranger.com/en_US/camera-trap/icuserver",
    description: "",
    actions: []
  },
  {
    name: "iTrack",
    id: "",
    value: "itrack",
    help_center_url: "https://support.earthranger.com/en_US/vehicle-trackers/itrack",
    description: "",
    actions: []
  },
  {
    name: "iTrackLive",
    id: "",
    value: "itracklive",
    help_center_url: "https://support.earthranger.com/en_US/vehicle-trackers/itracklive",
    description: "",
    actions: []
  },
  {
    name: "Kerlink Gateway",
    id: "",
    value: "kerlink",
    help_center_url: "https://support.earthranger.com/en_US/iot/kerlink",
    description: "",
    actions: []
  },
  {
    name: "Liquid Tech",
    id: "",
    value: "liquid-intelligence-technologies",
    help_center_url: "https://support.earthranger.com/en_US/iot/liquid-intelligence-technologies",
    description: "",
    actions: []
  },
  {
    name: "Lotek",
    id: "",
    value: "lotek",
    help_center_url: "https://support.earthranger.com/en_US/animal-tracking/lotek",
    description: "",
    actions: []
  },
  {
    name: "Mireo",
    id: "",
    value: "mireo",
    help_center_url: "https://support.earthranger.com/en_US/vehicle-trackers/mireo",
    description: "",
    actions: []
  },
  {
    name: "Movebank",
    id: "",
    value: "receiving-data-from-movebank",
    help_center_url: "https://support.earthranger.com/en_US/movebank/receiving-data-from-movebank",
    description: "",
    actions: []
  },
  {
    name: "NamTrack",
    id: "",
    value: "namtrack",
    help_center_url: "https://support.earthranger.com/en_US/vehicle-trackers/namtrack",
    description: "",
    actions: []
  },
  {
    name: "NAVSAT",
    id: "",
    value: "navsat",
    help_center_url: "https://support.earthranger.com/en_US/vehicle-trackers/navsat",
    description: "",
    actions: []
  },
  {
    name: "OroraTech",
    id: "",
    value: "ororatech",
    help_center_url: "https://support.earthranger.com/en_US/remote-imagery/ororatech",
    description: "",
    actions: []
  },
  {
    name: "Owley",
    id: "",
    value: "owley",
    help_center_url: "https://support.earthranger.com/en_US/animal-tracking/owley",
    description: "",
    actions: []
  },
  {
    name: "Savannah Tracking",
    id: "",
    value: "savannah-tracking",
    help_center_url: "https://support.earthranger.com/en_US/animal-tracking/savannah-tracking",
    description: "",
    actions: []
  },
  {
    name: "Sentinel",
    id: "",
    value: "sentinel",
    help_center_url: "https://support.earthranger.com/en_US/camera-trap/sentinel",
    description: "",
    actions: []
  },
  {
    name: "Sigfox",
    id: "",
    value: "sigfox",
    help_center_url: "https://support.earthranger.com/en_US/iot/sigfox",
    description: "",
    actions: []
  },
  {
    name: "SMART to EarthRanger",
    id: "",
    value: "receiving-data-from-smart-connect",
    help_center_url: "https://support.earthranger.com/en_US/smart/receiving-data-from-smart-connect",
    description: "",
    actions: []
  },
  {
    name: "SpoorTrack",
    id: "",
    value: "spoortrack",
    help_center_url: "https://support.earthranger.com/en_US/animal-tracking/spoortrack",
    description: "",
    actions: []
  },
  {
    name: "Traccar",
    id: "",
    value: "traccar",
    help_center_url: "https://support.earthranger.com/en_US/vehicle-trackers/traccar",
    description: "",
    actions: []
  },
  {
    name: "Track Solid",
    id: "",
    value: "track-solid",
    help_center_url: "https://support.earthranger.com/en_US/vehicle-trackers/track-solid",
    description: "",
    actions: []
  },
  {
    name: "TrackIt",
    id: "",
    value: "trackit",
    help_center_url: "https://support.earthranger.com/en_US/vehicle-trackers/trackit",
    description: "",
    actions: []
  },
  {
    name: "Ultimate Tracking",
    id: "",
    value: "ultimate-tracking",
    help_center_url: "https://support.earthranger.com/en_US/vehicle-trackers/ultimate-tracking",
    description: "",
    actions: []
  },
  {
    name: "JVA Eletric Fencing",
    id: "",
    value: "jva",
    help_center_url: "https://support.earthranger.com/en_US/iot/jva",
    description: "",
    actions: []
  },
  {
    name: "Wildlife Computers",
    id: "",
    value: "wildlife-computers",
    help_center_url: "https://support.earthranger.com/en_US/animal-tracking/wildlife-computers",
    description: "",
    actions: []
  }
];